import { Box } from "@mui/material"
import { styled } from "@mui/material/styles"

const StyledStyledBox = styled(Box)(({ theme }) => ({
  borderRadius: "8px",
  transition: "all 0.5s ease",
  "&:hover": {
    boxShadow: "0px 3px 38px 0px rgb(205 205 205)"
  },
  "& a": {
    textDecoration: "none",
    color: theme.palette.grey[900]
  }
}))

const LinkPaperBox = (props) => {
  const { children } = props

  return (
    <StyledStyledBox mt={2} spacing={3} p={3} bgcolor="background.paper" borderRadius="2px" {...props}>
      {children}
    </StyledStyledBox>
  )
}

export default LinkPaperBox
